import reduxCatch from 'redux-catch';

export const errorHandler = windowObj => (error, getState, action) => {
  // directly log the error to the console in ALL cases,
  // not just via a debug log. this will help us debug
  // production errors for users.
  if (windowObj.console && windowObj.console.error) {
    windowObj.console.error(error);
  }

  // dispatch the error to Sentry, sending the current
  // redux state and the action that failed as we go.
  if (windowObj.Raven) {
    windowObj.Raven.context({ state: getState(), action });
    windowObj.Raven.captureException(error);
  }

  // Log the error to Loggly as well.
  if (windowObj._LTracker) {
    const errorToSend = { type: 'UnhandledReduxError', error };

    if (windowObj.Raven) {
      errorToSend.context = windowObj.Raven.getContext();
    }

    windowObj._LTracker.push(errorToSend);
  }
};

export default windowObj => reduxCatch(errorHandler(windowObj));



// WEBPACK FOOTER //
// ./src/middleware/unhandledError.js